import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import { formatDate } from '../../helpers';
import PaginatedList from '../../components/PaginatedList';
import ListFilterBox from '../../components/ListFilterBox';

const ControlHeader = props => (
  <Row className="tools">
    <Col sm={4} className="table-header">
      <ListFilterBox
        onChange={props.filterBoxChange}
        fuzzyFilterFactory={props.fuzzyFilterFactory}
      />
    </Col>
    <Col sm={2} className="table-header" />
    <Col sm={3} className="table-header">
      {/*<div className="checkbox-wrapper">
        <input type="checkbox" name="archiveCheckboxTools" id="archiveCheckboxTools" className="archive-checkbox" />
        <label htmlFor="archiveCheckboxTools" className="checkbox-label">Show Archived</label>
      </div>*/}
    </Col>
    <Col sm={3} className="table-header">
      <Button
        bsStyle="primary"
        className="relative-padding"
        type="submit"
        onClick={props.addButtonClick}
      >
        Add Sub-Account
      </Button>
    </Col>
  </Row>
);

const LineItem = props => {
  const { currentCustomer, item } = props;
  return (
    <Row key={item.id}>
      <Col sm={4} className="table-entry">
        <Link to={`/customer/${currentCustomer.id}/sub-accounts/${item.id}`}>
          {item.name}
        </Link>
      </Col>
      {/*<Col sm={3} className="table-entry">
        <ParentOrgName id={item.parentId} />
      </Col>*/}
      <Col sm={3} className="table-entry">
        {formatDate(item.dateCreated, true)}
      </Col>
      <Col sm={3} className="table-entry">
        {formatDate(item.dateUpdated, true)}
      </Col>
      <Col sm={2} className="table-entry">
        {/*<Button
          className="action-button"
          bsStyle="link"
          onClick={props.removeItem}
        >
          Remove
        </Button>*/}
      </Col>
    </Row>
  );
};

class CustomerLocations extends React.Component {
  static displayName = 'CustomerLocations';

  constructor(props) {
    super(props);

    this.state = {
      filterValue: ''
    };
    this.fuzzyFilterFactory = fuzzyFilterFactory();
  }

  componentDidMount() {
    const customerId = this.props.params.customerId;
    this.props.getCurrentCustomerLocations(customerId);
    this.screenReaderContent.focus();
  }

  removeLocation = () => {
    // TODO: archive location
    // confirm(' Are you sure? This will archive the location.')
  };

  updateFilterValue = filterValue => {
    this.setState({ filterValue: filterValue || '' });
  };

  addButtonClick = () => {
    const { customerId } = this.props.params;
    localStorage.setItem(
      'backUrl',
      `/customers/${customerId}/sub-account-list`
    );
    this.props.router.push(`/customer/${customerId}/sub-accounts/new`);
  };

  render() {
    const { currentCustomer } = this.props;
    const locations = currentCustomer.locations;

    const LineItemWrapper = props => (
      <LineItem
        {...props}
        removeItem={this.removeLocation}
        currentCustomer={currentCustomer}
      />
    );

    return (
      <div>
        <Row />
        <h3
          className="screen-reader-only"
          tabIndex="-1"
          ref={i => (this.screenReaderContent = i)}
        >
          Showing sub-accounts for customer {this.props.currentCustomer.name}
        </h3>

        <ControlHeader
          filterBoxChange={this.updateFilterValue}
          fuzzyFilterFactory={this.fuzzyFilterFactory}
          addButtonClick={this.addButtonClick}
        />

        <Row>
          <Col sm={4} className="table-header">
            Sub-Account name
          </Col>
          {/*<Col sm={3} className="table-header">Managed By</Col>*/}
          <Col sm={3} className="table-header">
            Date created
          </Col>
          <Col sm={3} className="table-header">
            Date updated
          </Col>
          <Col sm={2} className="table-header">
            Action
          </Col>
        </Row>
        <hr />

        <PaginatedList
          filterValue={this.state.filterValue}
          component={LineItemWrapper}
          items={locations}
          fuzzyFilterFactory={this.fuzzyFilterFactory}
          pluralName="sub-accounts"
        />
      </div>
    );
  }
}

export default CustomerLocations;



// WEBPACK FOOTER //
// ./src/containers/customer/CustomerLocations.js